<template>
  <new-layout
    :backgroundImage='backgroundImage'
    :backgroundImage2x='backgroundImage2x'
    :showLogo="false"
  >
    <SignUpCard class='sign-card'/>
  </new-layout>
</template>

<script>
import { mapActions } from 'vuex';
import { displayTexts } from '../utils/displayTexts';
import { colors } from '../utils/colors';
import NewLayout from '../components/NewLayout.vue';
import SignUpCard from '../components/SignUpCard.vue';

export default {
  name: 'sign-up',
  data: () => ({
    signUpOrigin: null,
    backgroundImage: 'https://cdn.parcelex.com.br/assets/v3/persons/woman-with-bags-big.png',
    backgroundImage2x: 'https://cdn.parcelex.com.br/assets/v3/persons/woman-with-bags-big@2x.png',
    displayTexts,
  }),
  components: {
    NewLayout,
    SignUpCard,
  },
  computed: {
    gradientColors() {
      return colors.BLUE;
    },
  },
  methods: {
    ...mapActions('login', ['sendEvent', 'setSource']),
  },
  mounted() {
    this.setSource('site');
    this.sendEvent({ type: 'application' });
  },
  created() {
    this.signUpOrigin = this.$route.query.origin;
  },
};
</script>

<style lang='scss' scoped>

$tablet-width: 768px;
$desktop-width: 900px;

.sign-card{
  max-width: 452px;
}

</style>
